import { Injectable } from '@angular/core';
import { City } from '@city/const';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class CityAnalyticsService {
  constructor(private analyticsService: AnalyticsService) {}

  onChangeCity(oldCity: City, newCity: City): void {
    this.analyticsService.sendEvent({
      event: 'common_event',
      eventCateg: 'Смена города',
      eventAction: `С ${oldCity.baseStoreId} на ${newCity.baseStoreId}`,
      eventLabel: `С ${oldCity.name} на ${newCity.name}`,
      eventNonInteraction: false,
    });
  }
}
